import React from "react";
import { Skull } from "lucide-react";
import SEO from "@/components/common/SEO";
import { EQUIPO } from "@/data/staticContent";

export default function Equipo() {
    return (
        <>
            <SEO
                title="Equipo ejecutivo · Los seis que nunca me fallaron"
                description="El organigrama interno de Autodestrucción S.A.: Director de Evasión, Gerente de Excusas, Manager en Recaídas, Jefe de Finanzas del Caos. Todos somos yo."
                path="/equipo"
                keywords="adicción, autoengaño, evasión, recaída, autoconocimiento"
            />

            <section className="grain relative py-20 md:py-28 border-b border-[var(--line)]">
                <div className="container-x">
                    <p className="eyebrow mb-6">Organigrama · Sección 05</p>
                    <h1 className="font-display text-6xl md:text-8xl lg:text-9xl leading-[0.85] tracking-tight mb-6">
                        Nuestro{" "}
                        <span className="text-[var(--danger)]">equipo</span>{" "}
                        ejecutivo
                    </h1>
                    <p className="font-mono text-base md:text-lg text-[var(--paper)] max-w-2xl leading-relaxed">
                        Aquí están los que nunca me fallaron: mi equipo de alto
                        rendimiento en pérdida de dignidad. Todos somos yo.
                        Tristemente.
                    </p>
                </div>
            </section>

            <section className="py-16 md:py-24" data-testid="equipo-list">
                <div className="container-x">
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[var(--line)] border border-[var(--line)]">
                        {EQUIPO.map((m, i) => (
                            <article
                                key={m.name}
                                className="bg-[#1a1a1a] p-8 hover:bg-[#0d0d0d] transition-colors"
                                data-testid={`equipo-card-${i}`}
                            >
                                <div className="flex items-start justify-between mb-6">
                                    <Skull className="w-10 h-10 text-[var(--danger)]" />
                                    <div className="text-right">
                                        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[var(--ink-dim)]">
                                            ID-{String(i + 1).padStart(3, "0")}
                                        </p>
                                        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[var(--danger)] mt-1">
                                            Activo · 20 años
                                        </p>
                                    </div>
                                </div>
                                <h2 className="font-display text-3xl mb-2 text-[var(--paper-2)] leading-tight">
                                    {m.name}
                                </h2>
                                <p className="font-mono text-xs uppercase tracking-[0.2em] text-[var(--warning)] mb-5">
                                    {m.person}
                                </p>
                                <p className="font-mono text-sm text-[var(--ink-muted)] leading-relaxed mb-6">
                                    {m.bio}
                                </p>
                                <div className="border-t border-dashed border-[var(--ink-dim)] pt-4 flex justify-between items-baseline">
                                    <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--ink-dim)]">
                                        KPI principal
                                    </span>
                                    <span className="font-display text-xl text-[var(--danger)]">
                                        {m.kpi}
                                    </span>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}
